import API from '../../../../libs/api';

const PROMPT_CLASS = 'LocationDescriptionPrompt';

export async function getLocationDescriptionPrompt(businessType, businessId, params) {
  return API.textCompletion(businessType, businessId, PROMPT_CLASS, params);
}
